const isEmpty = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

const validatePersonal = (formState) => {
  const missing = [];
  if (isEmpty(formState.firstName)) missing.push("First Name");
  if (isEmpty(formState.lastName)) missing.push("Last Name");
  if (isEmpty(formState.employee_code)) missing.push("Employee Code");
  if (isEmpty(formState.country)) missing.push("Country");
  if (isEmpty(formState.city)) missing.push("City");
  return missing;
};

const validateOfficial = (formState) => {
  const missing = [];
  if (isEmpty(formState.hire_date)) missing.push("Hire Date");
  if (isEmpty(formState.status)) missing.push("Status");
  if (isEmpty(formState.joining_date)) missing.push("Joining Date");
  if (isEmpty(formState.employee_type)) missing.push("Employment Type");
  if (isEmpty(formState.shift)) missing.push("Shift");
  if (isEmpty(formState.location)) missing.push("Work Location");
  if (isEmpty(formState.department)) missing.push("Department");
  if (isEmpty(formState.designation)) missing.push("Designation");

  if (formState.employee_type === "contract") {
    if (isEmpty(formState.contract_start_date)) missing.push("Contract Start Date");
    if (isEmpty(formState.contract_end_date)) missing.push("Contract End Date");
  }

  if (["regular", "internship"].includes(formState.employee_type)) {
    if (isEmpty(formState.probation_months)) {
      missing.push(`No. of Months ${formState.employee_type}`);
    }
    if (isEmpty(formState.p_confirmation_date)) {
      missing.push("Permanent Confirmation Date");
    }
  }

  return missing;
};

const validateSalary = (formState) => {
  const missing = [];
  const salaryType = formState.salary_type || "monthly";

  if (isEmpty(formState.salary_type)) missing.push("Salary Type");

  if (salaryType === "monthly") {
    if (isEmpty(formState.day_calculation)) missing.push("Days Calculation");
    if (formState.day_calculation === "fixed" && isEmpty(formState.fixed_Days)) {
      missing.push("Number of Working Days");
    }
    if (isEmpty(formState.monthly_salary)) missing.push("Monthly Salary");
  }

  if (salaryType === "hourly") {
    if (isEmpty(formState.hourly_rate)) missing.push("Hourly Rate");
    if (isEmpty(formState.paid_type)) missing.push("Paid Type");
  }

  if (salaryType === "one_time") {
    if (isEmpty(formState.total_ammount)) missing.push("Total Amount");
    if (isEmpty(formState.paid_type)) missing.push("Paid Type");
    if (isEmpty(formState.paid_ammount)) missing.push("Paid Amount");
    if (isEmpty(formState.advance_payment)) missing.push("Advance Payment");
  }

  return missing;
};

const validateTimeOff = (formState) => {
  const missing = [];
  if (isEmpty(formState.annual_leave_policy)) missing.push("Leave Policy");
  return missing;
};

const validateDependant = (formState) => {
  const missing = [];
  if (isEmpty(formState.relationship_type)) missing.push("Relationship");
  if (isEmpty(formState.emergency_firstName)) missing.push("First Name");
  if (isEmpty(formState.emergency_lastName)) missing.push("Last Name");
  return missing;
};

const validateAttendance = () => [];

const stepValidators = [
  validatePersonal,
  validateOfficial,
  validateSalary,
  validateTimeOff,
  validateDependant,
  validateAttendance,
];

export const validateStep = (step, formState) => {
  const validator = stepValidators[step];
  return validator ? validator(formState) : [];
};

export const validateAllSteps = (formState) => {
  const errors = {};
  stepValidators.forEach((validator, index) => {
    const missing = validator(formState);
    if (missing.length > 0) {
      errors[index] = missing;
    }
  });
  return errors;
};

export const formatMissingFieldsMessage = (missingFields) => {
  if (missingFields.length === 0) return "";
  const fieldList = missingFields.join(", ");
  const verb = missingFields.length === 1 ? "is" : "are";
  return `${fieldList} ${verb} missing`;
};
